<template>
	<div class='inspection-type'>
		<div v-if='!editMode &&  lpo.inspection_type'>
			<span class='type-span' @click='enableEditMode'>
				{{ lpo.inspection_type_id === '5' ? 'Насаждение с более 50% ветровала, бурелома' : lpo.inspection_type }}
				<i class='fa fa-edit'></i>
			</span>
			<div v-if='isInstrum'>
				<custom-p-checkbox
					:value='needVisual'
					@input='onNeedVisualChange'
					:disabled='!actLpoIsDraft'
					label='Включить в Акт Раздел 1. Визуальное обследование'
				/>
			</div>
		

			
		</div>

		<div v-else class='grid'>
			<div
				v-for='type in inspectionTypeList'
				:key='type.id'
				@click='select(type)'
				class='inspection-type-box'
				:class='{ selected: type.id === lpo.inspection_type_id }'
			>
				{{ type.id === '5' ? 'Насаждение с более 50% ветровала, бурелома' : type.name }}
			</div>
		</div>
	</div>
</template>

<script>
	import { mapActions } from 'vuex';

	export default {
		name: 'InspectionType',
		data() {
			return {
				editMode: false
			};
		},
		computed: {
			actLpoIsDraft() { return this.$store.getters['lpoData/actLpoIsDraft']; },

			lpo() {
				return this.$store.state.selectedLpo.lpo;
			},
			info_inspection_type() {
				return this.$store.state.catalogs['info_inspection_type'];
			},

			inspectionTypeList() {
				return this.$store.state.selectedLpo.inspectionTypeList;
			},

			needVisual() {
				return this.lpo.need_visual === 't' ? true : false;
			},
			isInstrum() {
				return this.lpo.inspection_type_id === '1' ||
					this.lpo.inspection_type_id === '2' ||
					this.lpo.inspection_type_id === '3' ||
					this.lpo.inspection_type_id === '4' ||
					this.lpo.inspection_type_id === '5';
			}

		},
		methods: {

			onNeedVisualChange(checked) {
				this.toggleNeedVisual(checked).then(res => {
					return this.updateLpo(this.lpo.lpo_id);
				});
			},

			select(type) {
				if (type.id === this.lpo.inspection_type_id) {
					this.disableEditMode();
					return;
				}

				if (this.lpo.inspection_type_id !== null) {
					const confirmation = confirm('Изменить способ перечета? Это удалит весь перечет на данном участке');
					if (!confirmation) {
						// this.disableEditMode();
						return;
					}
				}

				const valueList = [
					{ field: 'inspection_type_id', value: type.id },
					// { field: 'need_visual', value: false }
				];

				this.saveLpoValue(valueList).then(res => {
					return this.updateLpo(this.lpo.lpo_id);
				}).then(res => {
					this.removeModelTreeList();
					return this.removeRecount().then(res => {
						return this.updateRecount();
					});
				}).then(res => {
					this.disableEditMode();
				});
			},

			enableEditMode() {
				if (!this.actLpoIsDraft) {
					return;
				}

				this.editMode = true;
				this.getInspectionTypeList();
			},
			disableEditMode() {
				this.editMode = false;
			},

			...mapActions('selectedLpo', [
				'saveLpoValue',
				'toggleNeedVisual',
				'getInspectionTypeList',
				'updateLpo',
			]),

			...mapActions('selectedLpo/recount', [
				'removeRecount',
				'updateRecount',
				'removeModelTreeList',
			])
		},
		created() {
			if (!this.info_inspection_type.length) {
				this.$store.dispatch('getCatalog', 'info_inspection_type');
			}
			this.getInspectionTypeList();
		}
	};
</script>

<style scoped src='@/style/grid.css'></style>

<style scoped>
	.inspection-type-box {
		border: 1px solid black;
		cursor: pointer;
		padding: 10px;
	}
	.inspection-type-box.selected {
		background-color: gray;
		color: white;
	}
	.inspection-type-box:hover {
		background-color: black;
		color: white;
	}
	

	.type-span {
		display: inline-block;
		font-weight: bold;
		cursor: pointer;
		margin-bottom: 10px;
		padding: 5px 2px;
	}
	.type-span:hover {
		background-color: black;
		border-radius: 5px;
		
		color: white;
	}
	.vis-include-span {
		display: inline-block;
		font-style: italic;
		margin-top: 10px;
	}
</style>